import { useState } from "react";
import {   Boost,
  Quote,
  Wellness,
  Affirmation,
  Encouragement, } from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import { CardDetailsModal } from "@components/ui/CardDetailsModal";

const MotivationCardsView = ({ heading = "", content = {} }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleOpen = (data) => {
    setSelectedData(data);
    setOpen(true);
  };

  // Transform the API data into the card format
  const getNutrientData = () => {
      
    return [
      {
        label: "Quote of the Day",
        key: "quote",
        icon: <Quote className="w-[28px] h-[28px]" />,
        tabColor: "#F0FFFF",
        value: content?.quote || "",
        model_value: content?.quote_explanation || "",
      },
      {
        label: "Personalized Boost",
        key: "personalized_boost",
        icon: <Boost className="w-[28px] h-[28px]" />,
        tabColor: "#F0FFFF",
        value: content?.personalized_boost || "",
        model_value: content?.personalized_boost_explanation || "",
      },
      {
        label: "Wellness Tip",
        key: "wellness_tip",
        icon: <Wellness className="w-[28px] h-[28px]" />,
        tabColor: "#F0FFFF",
        value: content?.wellness_tip || "",
        model_value: content?.wellness_tip_explanation || "",
      },
      {
        label: "Positive Affirmation",
        key: "affirmation",
        icon: <Affirmation className="w-[28px] h-[28px]" />,
        tabColor: "#F0FFFF",
        value: content?.affirmation || "",
        model_value: content?.affirmation_explanation || "",
      },
      {
        label: "Encouragement of the Day",
        key: "encouragement",
        icon: <Encouragement className="w-[28px] h-[28px]" />,
        tabColor: "#FFF0FF",
        value: content?.encouragement || "",
        model_value: content?.encouragement_explanation || "",
      },
    ];
  };

  const nutrientData = getNutrientData();

  const Card = ({ label, icon, value, tabColor, model_value, onClick }) => (
    <div
      className="py-4 px-4 md:py-5 md:px-6 rounded-[16px] bg-white border border-[#E6E6E6] flex flex-col gap-2  hover:shadow-lg transition-shadow"
      style={{
        boxShadow: "7px 7px 9.5px 0px #0000000D",
      }}
      onClick={onClick}
    >
      <div className="relative">
        <div
          className={`absolute border border-[#0575e6] -left-3 -top-1 rounded-full min-w-12 min-h-12 flex items-center justify-center`}
          style={{ backgroundColor: tabColor }}
        >
          {icon}
        </div>
        <p className="bg-gradient-to-r from-[#0771EF] to-[#15AAFC] text-[14px] lg:text-[15px] font-[600] text-white py-2 px-8 md:px-10 rounded-full text-center lg:text-start min-w-[180px] md:min-w-[200px] max-w-full">
          {label}
        </p>
      </div>
      <div className="mt-2 md:mt-0">
        <p className="text-[14px] lg:text-[16px] font-[600] text-[#606060] font-[Lato]">
          {value}
        </p>
      </div>
      <div className="border-t border-dashed border-[#E7E7E7] pt-2">
        <p className="text-[14px] font-[400] text-[#898787] font-[Lato]">
          {model_value}
        </p>
      </div>
    </div>
  );

  return (
    <div className="p-6 bg-gradient-to-r from-[#0771EF] to-[#15AAFC] rounded-lg">
      <h1 className="text-center text-white mb-6 text-xl font-bold">
        {heading}
      </h1>
      
      {/* First Row - 3 cards */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mb-5">
        {nutrientData.slice(0, 3).map((item, index) => (
          <Card
            key={index}
            label={item.label}
            icon={item.icon}
            value={item.value}
            tabColor={item.tabColor}
            model_value={item.model_value}
            // onClick={() => handleOpen(item)}
          />
        ))}
      </div>

      {/* Second Row - 2 cards centered */}
      <div className="flex justify-center w-full">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 w-full md:max-w-4xl">
          {nutrientData.slice(3).map((item, index) => (
            <Card
              key={index + 3}
              label={item.label}
              icon={item.icon}
              value={item.value}
              tabColor={item.tabColor}
              model_value={item.model_value}
              // onClick={() => handleOpen(item)}
            />
          ))}
        </div>
      </div>
      
      <CardDetailsModal 
        open={open} 
        setOpen={setOpen} 
        data={selectedData} 
      />
    </div>
  );
};

export default MotivationCardsView;